<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'ModelChildRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    isCurrent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onSelected'],
  setup(_, { emit }) {
    const { pushGtm } = useGtm()
    const modelRef = ref(null)
    const selected = (item) => {
      emit('onSelected', item)
      pushGtm(modelRef.value)
    }
    return {
      modelRef,
      selected,
    }
  },
})
</script>

<template>
  <div
    ref="modelRef"
    v-ripple class="col-5 relative-position bg-white cursor-pointer rounded-borders q-mr-sm q-ma-xs"
    :class="[
      isCurrent ? 'border' : '',
    ]"
    :glasson-click="item.gtmKey"
    style="width: 160px"
    @click="selected(item)"
  >
    <q-badge
      v-if="item.isOnDev || item.isForChild"
      class="absolute-top-left text-small text-white text-weight-medium"
      style="z-index: 10; border-radius: 0 0 4px 0"
      :color="item.isOnDev ? 'grey-8' : 'kids'"
    >
      {{ item.isOnDev ? '開発中' : 'FOR KIDS' }}
    </q-badge>
    <q-img
      :src="item.url"
      :alt="item.value"
      height="100px"
      fit="contain"
      fetchpriority="high"
    >
      <div
        v-if="isCurrent"
        class="absolute-top-right bg-transparent"
        style="padding: 2px 4px"
      >
        <q-avatar
          class="shadow-3"
          color="secondary"
          text-color="white"
          size="sm"
        >
          <q-icon name="checked" size="16px" />
        </q-avatar>
      </div>
      <div
        style="padding: 2px 4px"
        class="absolute-bottom bg-transparent text-caption text-center" :class="[
          isCurrent
            ? 'text-weight-bold text-primary'
            : 'text-weight-medium text-dark',
        ]"
      >
        {{ item.uiLabel }}
      </div>
    </q-img>
  </div>
</template>
